import React, { useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import StickyNavbar from "../navbar";
import QuizPopup from "./QuizPopup";

const Steps = () => {
   const [showQuiz, setShowQuiz] = useState(false);
  
    const handleQuizComplete = (answers) => {
      console.log("User answers:", answers);
      // You can process the answers here
    };
  return (
    <div>
      <StickyNavbar />
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
        className="bg-white text-black p-4 lg:mt-10 mt-20 sm:p-10 lg:px-20 text-lg space-y-10"
      >
        <motion.div
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="space-y-3"
        >
          <h2 className="text-2xl sm:text-3xl lg:text-4xl my-10 font-bold text-center capitalize">
            Stages in the Research Cycle
          </h2>
        </motion.div>
    <motion.div
                            className=" rounded-lg p-4"
                            whileHover={{ scale: 1.05 }}
                            transition={{ duration: 0.3 }}
                          >
                            <div className="flex justify-center">
                              <img
                                src="/images/cycle.svg"
                                alt="Community health worker engaging with locals"
                                className="w-full max-w-md rounded-md"
                              />
                            </div>
                           
                          </motion.div>


        <motion.div
          initial={{ x: -50, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.6 }}
          className="space-y-3"
        >
          <h2 className="text-xl font-bold mb-2 text-[#005FFF]">Identify a problem</h2>
          <p>
            The research process begins by looking at a health issue in the
            community that we want to understand better. If we think back to
            when we looked at one of the reasons why we do research; we research
            to solve problems. For example, we might notice that there are lots
            of cases of waterborne diseases like diarrhoea in the community; we
            have noticed that this is a problem and this then becomes our reason
            for doing research.
          </p>
        </motion.div>

        <motion.div
          initial={{ x: 50, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.6 }}
          className="space-y-3"
        >
          <h2 className="text-xl font-bold mb-2 text-[#005FFF]">Describe the problem</h2>
          <p>
            We then need to describe the problem in detail. Ask yourself and try
            to answer questions like:
          </p>
          <ul className="list-disc list-inside space-y-3">
            <li>What is the nature of the problem?</li>
            <li>How big is the problem?</li>
            <li>Who does it affect the most?</li>
            <li>What are the consequences?</li>
            <li>Are there different age groups more or less affected?</li>
            <li>Are specific areas more or less affected?</li>
          </ul>
        </motion.div>

        <motion.div
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.6 }}
          className="space-y-3"
        >
          <h2 className="text-xl font-bold mb-2 text-[#005FFF]">
            What are the possible causes of the problem?
          </h2>
          <p>
            We then need to describe the problem in detail. Ask yourself and try
            to answer questions like:
          </p>
          <ul className="list-disc list-inside space-y-3">
            <li>
              Could limited access to clean water, or poor sanitation be playing
              a part?
            </li>
          </ul>
        </motion.div>

        <motion.div
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.6 }}
          className="space-y-3"
        >
          <h2 className="text-xl font-bold mb-2 text-[#005FFF]">
            What information about the problem already exists?
          </h2>
          <p>
            We need to check if there is any information about the problem that
            we can use; this might be from research that has already been done
            elsewhere. Doing this is called carrying out a literature review.
          </p>
          <ul className="list-disc list-inside space-y-3">
            <li>Journals, articles and books: Reading studies, reports or books that have already been written focusing on the same health problem are a good place to begin. Other people have likely done similar research about cases of diarrhoea in other communities and we could learn from these.</li>
            <li>Data: Is there data about the community that we can use, that would be useful to the project, such as health or patient records?</li>
            <li>Policies and guidelines: Check to see if there are government health policies, guidelines, or recommendations that have already been made because of the problem.</li>
          </ul>
          <p>
            Using information that has already been created and reported, can
            save time and help you to decide on a starting point for your
            research. It might also give you solutions that have worked (or not
            worked) in similar communities.
          </p>
        </motion.div>
        <motion.div
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.6 }}
          className="space-y-3"
        > 
          <h2 className="text-xl font-bold mb-2 text-[#005FFF]">
            Look for solutions that already exist
          </h2>
          <p>
            Building on from the last step, it is important to find out if the
            issue has already been solved elsewhere. If solutions have been
            found, then we need to ask ourselves why it’s not being used in our
            community.
          </p>
          <ul className="list-disc list-inside space-y-3">
            <li>
              Is it because of lack of awareness, lack of resources, or
              something else?
            </li>
          </ul>
          </motion.div>

       <motion.div
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.6 }}
          className="space-y-3"
        > 
          <h2 className="text-xl font-bold mb-2 text-[#005FFF]">
            Identify an aspect of the problem to study
          </h2>
          <p>
            Now that we understand the problem better, its causes, and what we
            already know about it, we need to narrow down what our research is
            going to focus on. It is probably too big of a task to try and
            research everything there is to know about diarrhoea, so instead we
            can choose to focus on answering a smaller, more manageable
            question.
          </p>
          <p>
            By following the steps above, you may have found from your
            brainstorming and reading that that water sources have been linked
            to the issue of diarrhoea. You may also know already that the issue
            in your community is common in young children.
          </p>
          <p>
            So you could narrow down your question and ask “How do sources of
            drinking water and water cleaning practices in the community relate
            to cases of diarrhoea among children under five?”
          </p>
        </motion.div>

        {/* <motion.div
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.6 }}
          className="space-y-3"
        > 
          <h2 className="text-xl font-bold mb-2 lg:text-left text-center text-[#005FFF]">
            4B: Healthcare Facility Training
          </h2>
          <ul className="list-disc list-inside space-y-3">
            <li>6 facilities, 3 per state</li>
            <li>60 people in total</li>
            <li>
              1 head of facility, 1 local government epidemiologist, 3 CHW’s, 1
              CHO
            </li>
            <li>Trainees arrive Monday</li>
            <li>Training days are Tuesday - Thursday</li>
          </ul>
        </motion.div> */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8 }}
          className="flex justify-between mt-10"
        >
          <Link to="/chapter4">
            <button className="bg-blue-900 text-white px-3 py-2 rounded-lg hover:bg-blue-700">
              Previous
            </button>
          </Link>
          <button
            onClick={() => setShowQuiz(true)}
            className="bg-white text-blue-800 border border-blue-800 px-1 lg:px-3 py-2 rounded-lg "
          >
            Test Your Knowledge
          </button>
          <Link to="/chapter5/video">
            <button className="bg-blue-900 text-white px-3 py-2 rounded-lg hover:bg-blue-700">
              Next
            </button>
          </Link>
        </motion.div>
      </motion.div>
      {showQuiz && (
        <QuizPopup
          onClose={() => setShowQuiz(false)}
          onComplete={handleQuizComplete}
        />
      )}
    </div>
  );
};

export default Steps;
